import React from "react";

export default function Disclaimer() {
    return (
        <div className="bg-black text-gray-400 text-xs p-3 rounded-md max-w-7xl mx-auto mt-4">
            <p>
                Please note that all payments made for booking slots are non-refundable.
                Once a slot is reserved, the amount paid cannot be refunded under any
                circumstances. We appreciate your understanding and cooperation.
            </p>
        </div>
    );
}
